export default "__VITE_ASSET__B57HOYgq__"